import { useState } from 'react';
import { useSession } from './useSession';
import { REPLY_DRAFT_PREFIX as PREFIX } from '@/core/lib/replyDraftStorage';

const MAX_AGE = 7 * 86400_000;
function read(key: string | null): string {
  if (!key) return '';
  try {
    const raw = JSON.parse(sessionStorage.getItem(key) || 'null');
    if (raw && typeof raw.body === 'string' && Date.now() - raw.at < MAX_AGE) return raw.body;
    sessionStorage.removeItem(key);
  } catch {
    /* unavailable storage must not stop replying */
  }
  return '';
}
/** Tab-local, account-scoped recovery. Never automatically posts restored text. */
export function useReplyDraft(scope?: string) {
  const { currentUser } = useSession();
  const key = currentUser && scope ? PREFIX + currentUser.id + ':' + scope : null;
  const [state, setState] = useState(() => ({ key, value: '', saved: read(key) }));
  const value = state.key === key ? state.value : '';
  const saved = state.key === key ? state.saved : read(key);
  function setValue(body: string) {
    setState({ key, value: body, saved: '' });
    if (key)
      try {
        if (body) sessionStorage.setItem(key, JSON.stringify({ body, at: Date.now() }));
        else sessionStorage.removeItem(key);
      } catch {
        /* tab may be out of storage */
      }
  }
  return { value, saved, setValue, restore: () => setValue(saved), discard: () => setValue('') };
}
